(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ideia-forma-personalization"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalize = (value) =>
      String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();

    const getStampingValue = () => {
      const checked = document.querySelector('[data-option-name="Estampagem"]:checked');
      if (checked) return checked.value;

      const select = document.querySelector('select[name="options[Estampagem]"]');
      if (select) return select.value;

      return '';
    };

    const updateType = (container, personalizationDisabled = false) => {
      const selected = container.querySelector('[data-if-personalization-type]:checked');
      const textPanel = container.querySelector('[data-if-text-panel]');
      const photoPanel = container.querySelector('[data-if-photo-panel]');
      const textInput = container.querySelector('[data-if-text-input]');
      const photoInput = container.querySelector('[data-if-photo-input]');
      const isText = !personalizationDisabled && selected?.value === 'Texto';
      const isPhoto = !personalizationDisabled && selected?.value === 'Imagem';

      textPanel.hidden = !isText;
      photoPanel.hidden = !isPhoto;
      textInput.disabled = !isText;
      textInput.required = isText;
      photoInput.disabled = !isPhoto;
      photoInput.required = isPhoto;
    };

    const updateContainer = (container) => {
      const noStamping = normalize(getStampingValue()) === 'sem estampagem';
      const typeInputs = container.querySelectorAll('[data-if-personalization-type]');
      const noteInput = container.querySelector('[data-if-note-input]');

      container.hidden = noStamping;
      typeInputs.forEach((input) => {
        input.disabled = noStamping;
      });
      if (noteInput) noteInput.disabled = noStamping;

      updateType(container, noStamping);
    };

    const updateAll = () => {
      document.querySelectorAll('[data-if-personalization-switch]').forEach(updateContainer);
    };

    document.addEventListener('change', (event) => {
      if (
        event.target.matches('[data-option-name="Estampagem"], select[name="options[Estampagem]"], [data-if-personalization-type]')
      ) {
        updateAll();
      }
    });

    document.addEventListener('shopify:section:load', updateAll);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAll, { once: true });
    } else {
      updateAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
